import { useEffect, useMemo, useState } from 'react'

const MAX_TIMER_DELAY = 2_147_000_000

export function useAuthorityExpiryRefresh(expiries: Array<number | null | undefined>) {
  const expiryKey = useMemo(
    () =>
      expiries
        .filter((value): value is number => Number.isFinite(value))
        .sort((left, right) => left - right)
        .join(','),
    [expiries],
  )
  const [revision, setRevision] = useState(0)

  useEffect(() => {
    const now = Date.now()
    const nextExpiry = expiryKey
      .split(',')
      .map(Number)
      .find((value) => value > now)
    if (!nextExpiry) return
    const timer = window.setTimeout(
      () => setRevision((value) => value + 1),
      Math.min(MAX_TIMER_DELAY, Math.max(1, nextExpiry - now + 1)),
    )
    return () => window.clearTimeout(timer)
  }, [expiryKey, revision])

  return revision
}
